
    /** Generated by webpack-jst-loader */
    (function() {
      window.JST || (window.JST = {});
      window.JST["app_base/components/uploader/templates/uploader"] = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class='uploader_content_region'></div>\n<input\n  aria-label='Upload'\n  class='cloudinary-fileupload cloudinary_file_upload'\n  name='file'\n  type='file'\n  tabindex=-1>\n";
},"useData":true});
    }).call(this);
  